<app-header></app-header>
<app-navbar [selected]="'discounts'"></app-navbar>
<app-sidebar [items]="links"></app-sidebar>